const conversationSection = {
  INDENT: 1,
  INVOICE: 2,
  VOUCHER: 3,
  CHANGE_VEHICLE_TYPE: 4,
  VEHICLE_UTILIZATION: 5,
  INDENT_CANCEL: 6,
  INDENT_COMMENT: 7,
};
module.exports = { conversationSection };
